<template>
    <div class="index-index-container">
        <div class="index-atlas-list" v-for="(item, index) in wishOrderList" :key="index" @click="onJumpSingeProduct(item)">
            <div class="atlas-list-check" @click.stop="onWishListChange(index)">
                <van-checkbox class="checked" v-model="item.checked" shape="square" :checked-color="$theme.u_main_color_btn_bg" icon-size="16px" v-if="checkStatus"></van-checkbox>
            </div>
            <div class="atlas-list-image"><img :src="item.imageUrlsKey"></div>
            <div class="atlas-list-messa">
                <div class="title">{{item.itemName}}</div>
                <div class="class">{{item.categoryName}}</div>
                <div class="size">{{item.modelSize}}</div>
                <div class="price">￥{{item.price}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import http from "@/utils/axios";
import { isWeChatApplet } from "@/utils/util";
import utils from "@/utils/common";
export default {
    props: {
        checkStatus: { type: Boolean, default: false },
        orderParams: { type: Object, default: {} }
    },
    data () {
        return {
            wishOrderList: []
        }
    },
    created () {
        this.onGetWishListData()
    },
    methods: {
        onGetWishListData: function () {
            http({
                url: "discover/appuser/wishlist/orderList",
                method: "post",
                parmes: this.orderParams
            }).then(res => {
                if (res.code == 200) {
                    res.data.forEach(element => {
                        element.checked = false
                    })
                    this.wishOrderList = res.data
                }
            });
        },
        onWishListChange: function (index) {
            var idArray = new Array()
            this.wishOrderList[index].checked = !this.wishOrderList[index].checked
            this.wishOrderList.forEach(element => {
                if (element.checked) {
                    idArray.push(element.discoverId)
                }
            })
            this.$emit('checkStatus', {idArray: idArray});
        },
        onJumpSingeProduct: function (item) {
            this.$router.push({
                path: "/atlasProductDetail",
                query: {
                    atlasId: item.atlasId,
                    discoverId: item.discoverId
                }
            });
        }
    }
}
</script>

<style lang="less" scoped>
.index-index-container{
    display: flex;
    flex-direction: column;
    background-color: white;
    margin: 10px 0 108px;
}
.index-atlas-list{
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dddddd;
    padding: 30px 30px 30px 0;
}
.index-atlas-list:last-child{
    border-bottom: 0;
}
.atlas-list-check{
    display: flex;
    align-items: center;
    width: 70px;
}
.atlas-list-check .checked{
    margin: auto;
    border-radius: 4px;
    overflow: hidden;
}
.atlas-list-image img{
    display: block;
    width: 140px;
    height: 140px;
    object-fit: cover;
}
.atlas-list-messa{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-left: 20px;
}
.atlas-list-messa .title{
    font-size: 26px;
    font-weight: bolder;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.atlas-list-messa .class{
    font-size: 20px;
    color: #999999;
    padding-bottom: 10px;
}
.atlas-list-messa .size{
    font-size: 20px;
    color: #CCCCCC;
}
.atlas-list-messa .price{
    font-size: 24px;
    color: #ED3939;
    font-weight: bolder;
    padding-top: 10px;
}
</style>